import React, { useEffect, useState } from 'react'
import { Col, Row, Badge, Form, Table, Card, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import CustomModal from '../CustomModal/CustomModal';
import { useDispatch } from 'react-redux';
import { deleteRestaurant, fetchRestaurants } from '../../hooks/resturant';
import { deleteMainMeal, fetchMainMeals } from '../../hooks/MainMeals';

function CustomTable({ data, fiteration,body, customheader,ar_status, allData, setResturantID,header,actions,status,currentPage,resturantID,handleSubmit }) {
  const navigate=useNavigate();
  const dispatch=useDispatch()
const [studentData, setStudentData] = useState([]);
const [deleteShowModal, setDeleteShowModal] = useState(false);
const [itemID, setItemID] = useState(true);
    const handleChange = (id, field) => {
    setStudentData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, [field]: !item[field] }
          : item
      )
    );
  };
useEffect(() => {
  setStudentData(data);
}, [data]);
const deleteItem=()=>{
      dispatch(status=="restueant"?deleteRestaurant(itemID):status=="main-meals"?deleteMainMeal(itemID):"")
        .unwrap() // Allows us to use .then() / .catch() on the thunk result
        .then(() => {
          if(status=="restueant"){
  dispatch(fetchRestaurants({ page: currentPage }));
          alert(`تم المسح ${ar_status} بنجاح`);
setDeleteShowModal(false)
          }else if(status=="main-meals"){
  dispatch(fetchMainMeals());
          alert(`تم المسح ${ar_status} بنجاح`);
setDeleteShowModal(false)
          }
        })
        .catch((err) => {
          // Error is already handled in Redux, but you can do specific UI logic here
          console.error("Failed to save:", err);
        });
  
}
  return (

    <>
          <CustomModal show={deleteShowModal} onHide={() => setDeleteShowModal(false)}status={status}ar_status={ar_status} deleteItem={deleteItem}/>

      <Row className="mb-3">
        {fiteration?.map((item) => {
          return (
            <Col md={4} key={item?.id}>
              <Form.Select
  onChange={(e) => setResturantID(e.target.value)}
    value={resturantID || ""}
              >
                <option disabled>{item.title}</option>
                {item?.options?.map((op) => {
                  
                  return (
    <option key={op.id} value={op.id}>
                      <string>{op.name}</string>
                    </option>

                  )
                })}
              </Form.Select>
            </Col>
          )
        })}
        {/* {allData&&
        <Col md={8} className='text-start'>
          <small className="text-muted">عرض {currentData} من أصل  {allData}</small>
        </Col>
} */}
      </Row>

      {/* Table */}
      <Card className="shadow-sm">
        <Card.Body>
          <Table responsive hover>
            {customheader?
            customheader
          :
      <thead>
              <tr>
                {header.map((item) => {
                  return (
                    <th>{item}</th>
                  )
                })}
      
              </tr>
            </thead>

          }
      
  {body?body:
            <tbody>

            {studentData?.map(student => (
                <tr key={student.id}>
                  {student?.image && (<td>
                    <img src={student?.image}className='w-25 rounded'/>
                  </td>)}

                  <td>
                    <div className="fw-bold">{student.name}</div>
                    <small className="text-muted">{student.status}</small>
                  </td>
                  {student?.phone && (<td>{student.phone}</td>)}
                  {student?.military_number && (<td>{student.military_number}</td>)}
                  {student?.category && (<td>{student.category}</td>)}
        {status=="new-meal"&&     <td >
                                                <Form.Check
                  checked={student.breakfast}
                  className='w-25'
                  onChange={() => handleChange(student.id, "breakfast")}
                  label={student.breakfast ? "أريد" : "لا أريد"}
                />
                  </td>
}
            {status=="new-meal"&&         <td>     
                        <Form.Check
                  checked={student.lunch}
                  onChange={() => handleChange(student.id, "lunch")}
                  className='w-25'
                  label={student.lunch ? "أريد" : "لا أريد"}
                />
                </td>
}
{status=="new-meal"&&     
                <td>
                                  <Form.Check
                  checked={student.dinner}
                  onChange={() => handleChange(student.id, "dinner")}
                  className='w-25'
                  label={student.dinner ? "أريد" : "لا أريد"}
                />
                  </td>}
                  {student?.date &&status!=="student"&& (<td>{student.date}</td>)}
                  {student?.breakfastStatus && (<td>
                    <Badge bg={student.breakfastStatus.includes("لا") ? "danger" : "success"}>{student.breakfastStatus}</Badge>
                    <br />
                    <small className='text-muted mt-5'>{student?.date}</small>

                  </td>)}
                  {student?.lunchStatus && (<td>
                    <Badge bg={student.lunchStatus.includes("لا") ? "danger" : "success"}>{student.lunchStatus}</Badge>
                    <br />
                    <small className='text-muted mt-5'>{student?.date}</small>

                  </td>)}
                  {student?.dinnerStatus && (<td>
                    <Badge bg={student.dinnerStatus.includes("لا") ? "danger" : "success"}>{student.dinnerStatus}</Badge>
                    <br />
                    <small className='text-muted mt-5'>{student?.date}</small>

                  </td>)} 
                           {student?.active && (<td>
<Form.Check type="switch"checked={student?.active=="true"?true:false} />
                  </td>)}
    {actions && actions.length > 0 && (
  <td>
    {actions.map((action, index) => (
      <Badge
        key={index}
        bg={action === "تعديل" ? "primary" : "danger"}
        className="mx-1"
        onClick={()=>{
          if(action === "تعديل" ){
            navigate(`/dashboard/edit-${status}/${student.id}`)
            
          }else{
            setDeleteShowModal(true)
            setItemID(student?.id)
          }
        }}
      >
        {action}
      </Badge>
    ))}
  </td>
)}
                </tr>
              ))}

            </tbody>}
          </Table>
          {status=="new-meal"&&  <Button className='w-25'onClick={handleSubmit}>أرسال</Button>}
        </Card.Body>
      </Card>


    </>
  )
}

export default CustomTable